import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createCreditScoringATSSchema = z.object({
  quantity: z.number().optional(),
  remain: z.number(),
  souscriptionId: z.string().optional(),
  userId: z.string(),
});

export class CreateCreditScoringATSDto extends createZodDto(createCreditScoringATSSchema) {}
